import Vue from 'vue';
export function validatePermission(value) {
    const userRole = JSON.parse(localStorage.getItem("user_role"));
    /**
     *  tha user role pen superAdmin || CompanyAdmin man hai show all;
     */

    if (userRole === "superadmin" || userRole === "companyadmin") {
      return true;
    }


    if (value) {
        /**
         *
         * tha user me permission hai show menu in navbar;
         */
        const localPermission = JSON.parse(
            localStorage.getItem("userPermission")
        );
        return localPermission.some((el) => value.includes(el));
    }
}

Vue.prototype.$validatePermission = validatePermission

// import Vue from "vue";

// export function validatePermission(value) {
//   const userRole = JSON.parse(localStorage.getItem("user_role")) || "";

//   // If the user is a superadmin or companyadmin, they have full access
//   if (["superadmin", "companyadmin"].includes(userRole)) {
//     return true;
//   }

//   if (!value) return false; // If no permission is provided, deny access

//   const localPermission = JSON.parse(localStorage.getItem("userPermission")) || [];

//   return localPermission.some((perm) => value.includes(perm));
// }

// // Attach to Vue prototype for global access
// Vue.prototype.$validatePermission = validatePermission;
